module.exports = __webpack_public_path__ + "static/media/开户奖励@2x.d1d8e02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/开户奖励@2x.png
// module id = 1592
// module chunks = 0